document.addEventListener('DOMContentLoaded', function() {
    window.addEventListener('scroll', function() {
        let stickyHeader = this.document.querySelector('.header-section')
        if (stickyHeader && stickyHeader instanceof HTMLElement) {
            stickyHeader.style.top = `${this.document.querySelector('[id*="header_announcements"]')?.clientHeight}px`;
        }
    });
    window.addEventListener('resize', function() {
        let stickyHeader = this.document.querySelector('.header-section')
        if (stickyHeader && stickyHeader instanceof HTMLElement) {
         stickyHeader.style.top = `${this.document.querySelector('[id*="header_announcements"]')?.clientHeight}px`;
        }
    });
});